import { createMetricsFactory } from 'metrics-js';
export const Metrics = createMetricsFactory('framework-data-table');